import { isDematUser } from '../../utils/AuthUtil'
import KycUserHomePage from '../Home/KycUserHomePage'
import NonKycUserHomePage from '../Home/NonKycUserHomePage'

const Homepage = () => {
  return <>{isDematUser() ? <KycUserHomePage /> : <NonKycUserHomePage />}</>
}

export default Homepage
